import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '../store'
Vue.use(Router)

const router = new Router({
  routes,
  // mode: 'history'
})

router.beforeEach((to, from, next)=> {
  // 提现页面需要事先获取认证状态,如未认证,提现绑卡前需要先认证
  if (to.path == '/apply' || to.path == '/userinfo/withdraw' || to.path == '/userinfo/settings'){
    // if (router.app.$store.state.userInfo.certificationState === -1) router.app.$store.dispatch('getCertification');
    if (store.state.userInfo.certificationState === -1) store.dispatch('getCertification');
      next()
  }
  else{
      next()
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js